module.exports = __webpack_public_path__ + "img/slider1.7c0aeed7.png";